import { Injectable } from "@angular/core";
import { ObgConfigFeAdaptiveClientGaming } from "@obg/gaming.config";
import { ConfigService } from "@obg/ngx.global";
import { CookieService } from "@obg/ngx.global.evo";

@Injectable({
	providedIn: "root",
})
export class RecommendedGamesConfigService {
	constructor(
		private service: ConfigService<ObgConfigFeAdaptiveClientGaming>,
		private cookieService: CookieService
	) {}

	isEnabled(): boolean {
		const experiments = this.cookieService.get("obg-experiments");
		return (
			this.service.get((x) => x.gaming.recommendedGames.enabled, false) ||
			!!experiments?.toLowerCase().includes("game-recommendations")
		);
	}

	getAllEndpoint(): string {
		return this.service.get(
			(x) => x.gaming.recommendedGames.endpoints?.recommendedGames,
			"v1/gaming/recommendations"
		);
	}
}
